import React from 'react';
import type { PlaceTranslation } from '../../types/place';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box'

import { addDefaultSource, handleImgLoad } from '../../services/errorHandlers';
import ExpandableParagraph from '../common/ExpandableParagraph';
import { createImageUrl } from '../../services/data';
import { useTheme } from '../../themes/theme';

interface ExhibitionProps {
  id: string;
  information_photo: string;
  parent_id?: string;
  status?: string;
  children_list?: string[];
  type?: string;
  translations: PlaceTranslation[];
}

const Exhibition: React.FC<ExhibitionProps> = ({id, information_photo, parent_id, status, children_list, type, translations}) => {
    const navigate = useNavigate();
    const {slug} = useParams();
    const theme = useTheme()

    const paragraphCallback = () => {

    }

    const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        if (status !== "Published-Inactive") {
            navigate(`/${slug}/about/exhibition/${id}`)
        }
    }

    return (
        <Box className='exhibition thumbnail' width='100%'
            sx={{
                opacity: status === 'Published-Inactive'? '40%' : '',
                
            }}
        >
            <Link
                onClick={handleClick}
                to="#"
            >
                <Box 
                    sx={{ 
                        height:'18.5vh', 
                        position: 'relative', 
                        overflow: 'hidden', 
                        display: 'flex', 
                        flexDirection: 'column', 
                        borderRadius: '0.7rem', 
                    }}                    
                >
                    <img src={createImageUrl(information_photo)} alt='exhibition' onError={addDefaultSource} onLoad={handleImgLoad} loading='lazy'/>
                    <div style={{position: 'absolute', background: 'linear-gradient(180deg, rgba(0, 0, 0, 0.00) 68.56%, rgba(0, 0, 0, 0.90) 98.04%)', left: 0, bottom: 0, width: '100%', height:'100%', padding: 1}} />
                </Box>
            </Link>
            <Box className='exhibition-body' sx={{marginTop: '1rem', textAlign:'start'}}>
                <Box className='exhibition-header' sx={{marginBottom: '1rem'}}>
                    <Typography variant='body1'>{translations[0].information_title}</Typography>
                    &nbsp;|&nbsp;
                    <Typography color={theme.primary} variant='body1'>{translations[0].information_subtitle}</Typography>
                </Box>
                <ExpandableParagraph className='exhibition-text' content={translations[0].information_short_description} lineClamp={3} callback={paragraphCallback} />
            </Box>
        </Box>
    );
};

export default Exhibition;
